import { render, staticRenderFns } from "./DeleteSelectedClient.vue?vue&type=template&id=427f163c&"
import script from "./DeleteSelectedClient.vue?vue&type=script&lang=js&"
export * from "./DeleteSelectedClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports